import Header from "../../../components/base/Header.js";

// Original Goose header: Material Icons refresh/remove/close at 18px.
// Paths: google/material-design-icons, Apache-2.0.
const ICON_PATHS = {
  refresh: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z",
  minimize: "M19 13H5v-2h14v2z",
  close: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
};

export default class GooseHeader extends Header {
  render(ctx) {
    const header = super.render(ctx);
    for (const [action, path] of Object.entries(ICON_PATHS)) {
      header.querySelector(`.ws-btn-${action}`).innerHTML =
        `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="${path}"/></svg>`;
    }
    return header;
  }
}
